{
    "versions": [
        {
            "version": "Kurs Agile Fundamentals 06.01.2025",
            "contributors": [
                {
                    "name": "Álvarez",
                    "firstName": "Laura"
                },
                {
                    "name": "Bauer",
                    "firstName": "Moritz"
                },
                {
                    "name": "Bieber",
                    "firstName": "Deborah"
                },
                {
                    "name": "Erpenbeck",
                    "firstName": "Robert"
                },
                {
                    "name": "Klein",
                    "firstName": "Dino"
                },
                {
                    "name": "Kloß",
                    "firstName": "Peter"
                },
                {
                    "name": "Lübbert",
                    "firstName": "Thomas"
                }
            ]
        }
    ]
}
